import { createRoot } from 'react-dom/client';
import Modal from 'react-modal';

import HttpService from '@picsart/rc/services/http';

import { apiBaseUrl, needToRunApp } from 'configs/constants';
import setupContext from 'configs/context';

import type { IPicsartToolPubSub } from '@picsart/miniapps-sdk/dist/types/types';
import App from './app/App';
import LocalApp from './app/LocalApp';

const setup = ({ containerId, pubsub }: { containerId: string; pubsub?: IPicsartToolPubSub }) => {
  const container = document.getElementById(containerId) as HTMLElement;
  Modal.setAppElement(container);
  const root = createRoot(container);

  setupContext({ pubsub });

  // Replay native-bridge messages that were buffered by the inline script
  // in index.html before the SDK's window listener was attached. Without
  // this the Android wrapper's 'capturePort' arrives during Module
  // Federation's async preamble and is dropped.
  const replay = (window as unknown as { __miniappReplayMessages?: () => void }).__miniappReplayMessages;
  if (typeof replay === 'function') {
    replay();
  }

  if (needToRunApp) {
    HttpService.setConfig({ apiUrl: apiBaseUrl });
    root.render(<App />);
  } else {
    root.render(<LocalApp />);
  }

  return {
    unmount: () => root.unmount(),
  };
};

export default setup;
